import React from 'react';
import { useQuery } from '@apollo/client';
import { FeatureTopic, FeatureTopics as FeatureTopicsType } from '~/generated';
import { listFeatureTopics } from '~/queries/featureTopic';
import {
  Box,
  Skeleton,
  Stack,
  VStack,
  Heading,
  Text,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const FeatureTopics = () => {
  const { data } = useQuery<{
    featureTopics: FeatureTopicsType;
  }>(listFeatureTopics);
  const navigate = useNavigate();

  const topics = data?.featureTopics.data;
  if (topics === undefined) {
    return (
      <Stack>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    );
  }

  return (
    <Box>
      <VStack
        sx={{ width: '100%', display: 'flex' }}
        m={{ base: 0, md: 10 }}
        spacing={{ base: 0, md: 10 }}
        fontSize={{ base: '80%', md: 'inherit' }}
      >
        <Heading size="xl" my={{ base: 5, md: 0 }}>
          募集特集
        </Heading>
        <Box sx={{ textAlign: 'center' }}>
          <Text mb={2}>
            各特集ページ内に該当する募集を掲載しています。
            <br />
            特集や募集情報は随時、追加掲載させていただきます。
          </Text>
          <Alert status="info">
            <AlertIcon />
            リケイマッチはスカウトがメインであり、非公開募集が多いです。
            <br />
            スカウトを受け取るため、プロフィールも定期的に更新しましょう！
          </Alert>
        </Box>

        {topics.map((topic: FeatureTopic) => (
          <Box
            w={{ base: '100%', md: '700px' }}
            boxShadow={{ base: 'none', md: 'xl' }}
            sx={{
              border: '1px solid #E8E8E8',
              flexGrow: 1,
              boxSizing: 'border-box',
              display: 'flex',
            }}
            _hover={{
              opacity: 0.6,
              cursor: 'pointer',
            }}
            key={topic.id}
            onClick={() => navigate(topic.slug)}
          >
            <Box sx={{ flexGrow: 1, p: 4 }}>
              <Text>{topic.description}</Text>
              <Heading size="lg" sx={{ wordBreak: 'break-word', my: 4 }}>
                {topic.title}
              </Heading>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <ChevronRightIcon sx={{ fontSize: '4em', color: '#ccc' }} />
            </Box>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default FeatureTopics;
